// KEEP IN SYNC WITH OTHER parseDomain files!!
import { parse } from 'tldts';

export default function parseDomain(urlString: string): string {
  const trimmed = (urlString || '').toString().replace(/^\s+|\s+$/gm, '');
  const parsed = parse(trimmed, {
    allowPrivateDomains: true,
  });

  if (parsed.hostname === 'localhost') {
    return 'localhost';
  }
  if (parsed.isIp) {
    throw new Error('IP Address');
  }
  if (!parsed.domain) {
    throw new Error(`Invalid Domain: ${urlString}`);
  }

  if (!parsed.publicSuffix) {
    throw new Error(`Invalid public suffix: ${urlString}`);
  }

  if (!parsed.isIcann) {
    throw new Error(`Invalid ICann domain: ${urlString}`);
  }

  const hosted_domains = new Set(['wordpress.com', 'myshopify.com']);
  if (
    hosted_domains.has(parsed.domain || '') &&
    parsed.subdomain &&
    parsed.subdomain !== 'www'
  ) {
    const subdomain = parsed.subdomain.split('.');
    return `${subdomain[subdomain.length - 1]}.${parsed.domain}`;
  }
  return parsed.domain;
}

export function getHostname(input: string): string {
  try {
    const parsed = parse(input, {
      //   allowPrivateDomains: true,
      allowIcannDomains: true,
      validateHostname: true,
    });
    if (
      parsed &&
      parsed.hostname &&
      parsed.domain &&
      parsed.isIcann &&
      !parsed.isIp
    ) {
      return parsed.domain;
    }
  } catch {
    //
  }
  return '';
}
